import { render, staticRenderFns } from "./SummaryDinScenario.vue?vue&type=template&id=096398c2&scoped=true&"
import script from "./SummaryDinScenario.vue?vue&type=script&lang=ts&"
export * from "./SummaryDinScenario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096398c2",
  null
  
)

export default component.exports